import Section from "@/components/ui/section";
import React from "react";
import { m } from "framer-motion";
import Image from "next/image";
export default function Banner() {
  return (
    <Section className="bg-[#fafafa]">
      <m.div
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 100 }}
        transition={{ duration: 0.75 }}
        className="flex flex-col items-center w-full mt-20"
      >
        <div className="flex md:flex-row flex-col items-center justify-center w-full md:gap-12 gap-4">
          <div className="md:w-20 md:h-20 w-16 h-16 relative">
            <Image
              src={"/resilience-logo.webp"}
              alt={"resilience logo"}
              fill
              className="object-contain object-left"
              priority={true}
              sizes="(max-width: 479px) 400px,(max-width: 768px) 400px, (max-width: 1200px) 400px,(max-width: 1920px) 400px, 400px"
            />
          </div>
          <h1 className="text-blue font-semibold text-center heading">
            <span className="text-lightBlue">Our </span>Products
          </h1>
        </div>

        <p className="text-center lg:max-w-[900px] !leading-normal mt-4">
          Our innovative mobile application, Resilience Connect, coupled with a
          robust web portal, empowers organizations to efficiently register
          respondents and identify their eligibility for various initiatives.
          Designed for seamless tracking, this solution enables users to
          identify, monitor, and manage program applications with ease. Simplify
          your processes and focus on delivering impact with our cutting-edge
          platform.
        </p>
      </m.div>
    </Section>
  );
}
